export const BYLINE_DATE_FORMAT = "MMM dd, yyyy h:mm a";

export const TORONTO = "America/Toronto";

export const DEFAULT_TIMEZONE = TORONTO;

export const ONE_HOUR_IN_MS = 1000 * 60 * 60; // 1 hour in milliseconds

/**
 * Canadian Timezones
 *
 * There are 6 timezones that observe daylight savings time (DST) and 4 timezones that do not observe DST.
 * Canada Time Zones: https://www.zeitverschiebung.net/en/country/ca#timezones
 *
 * Daylight Time (_DT): March -> November (Summer)
 * Standard Time (_ST): November -> March (Winter)
 */
export const CANADA_TIME_ZONES = {
    // Timezones that observe daylight savings
    "America/Vancouver": {
        standard: { offset: 8, locale: "PST" },
        daylight: { offset: 7, locale: "PDT" },
    },
    "America/Edmonton": {
        standard: { offset: 7, locale: "MST" },
        daylight: { offset: 6, locale: "MDT" },
    },
    "America/Winnipeg": {
        standard: { offset: 6, locale: "CST" },
        daylight: { offset: 5, locale: "CDT" },
    },
    [TORONTO]: {
        standard: { offset: 5, locale: "EST" },
        daylight: { offset: 4, locale: "EDT" },
    },
    "America/Halifax": {
        standard: { offset: 4, locale: "AST" },
        daylight: { offset: 3, locale: "ADT" },
    },
    "America/St_Johns": {
        standard: { offset: 3.5, locale: "NST" },
        daylight: { offset: 2.5, locale: "NDT" },
    },
    // Timezones that do not observe daylight savings
    "America/Whitehorse": {
        standard: { offset: 7, locale: "MST" },
    },
    "America/Regina": {
        standard: { offset: 6, locale: "CST" },
    },
    "America/Coral_Harbour": {
        standard: { offset: 5, locale: "EST" },
    },
    "America/Blanc-Sablon": {
        standard: { offset: 4, locale: "AST" },
    },
};
